import { useContext, useState } from 'react';

import { cx } from '@hrworks/design-system/functions';
import { LocalizationContext } from '@hrworks/localization';

import { Icon } from '../Icon';
import { IconButton } from '../IconButton';
import { S } from './Alert.styles';
import type { AlertProps } from './Alert.types';

export const Alert = ({
  children,
  closeable,
  corner = 'rounded',
  onClose,
  color = 'primary',
  className,
  ...otherProps
}: AlertProps) => {
  const { translate } = useContext(LocalizationContext);
  const [visible, setVisible] = useState(true);

  const onClick = () => {
    setVisible(false);
    onClose?.();
  };

  return !visible && closeable ? null : (
    <S.Container
      className={cx(S.cls.Container, className)}
      role={color === 'danger' ? 'alert' : 'status'}
      corner={corner}
      $color={color}
      {...otherProps}
    >
      <S.Content className={S.cls.Content}>{children}</S.Content>
      {closeable && (
        <S.ButtonWrapper className={S.cls.ButtonWrapper} corner={corner}>
          <IconButton
            corner="square"
            type="button"
            variant="unstyled"
            aria-label={translate('alert-close')}
            onClick={onClick}
          >
            <Icon name="alert-close" />
          </IconButton>
        </S.ButtonWrapper>
      )}
    </S.Container>
  );
};
